module.exports = __webpack_public_path__ + "static/media/logo_transparent.e6a2d6da.png";